import React from "react";
import { STATS } from "@/lib/constants";

export const StatsStrip = () => {
    return (
        <section data-testid="stats-strip" className="bg-[#1A362B] text-white">
            <div className="container-prose py-14">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
                    {STATS.map((s, i) => (
                        <div key={s.label} data-testid={`stat-${i}`} className="text-center md:text-left">
                            <div className="font-serif text-4xl md:text-5xl text-[#E8C997] tracking-tight">{s.value}</div>
                            <div className="mt-2 text-xs tracking-[0.25em] uppercase text-white/70">{s.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsStrip;
